import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { intersection } from "ramda";
import List from "@mui/material/List";
import { selectAspectRatio, selectPagesCount } from "~/store/ducks/domain/config";
import { goToPage } from "~/store/middlewares/page";
import { selectIsGreaterThanMedium } from "~/store/ducks/application/browser";
import { closeSidebarLeft } from "~/store/ducks/user/uistate";
import { selectPageFlow, selectDisplayedPages } from "~/store/selectors/page";
import { absolutePageToRelative } from "~/utils";

import PagePreview from "./PagePreview";

function PageList({
  onNodeClick,
  className,
  aspectRatio,
  isGreaterThanMedium,
  closeSidebarLeft,
  pageFlow,
  pagesCount,
  displayedPages
}) {
  return (
    <List className={className} disablePadding>
      {pageFlow.map(group => {
        const isFirstPage = group[0] === 1;
        const isLastPage = group[0] === pagesCount;
        const isSelected = intersection(group, displayedPages).length > 0;
        const humanReadablePages = group.map(page => absolutePageToRelative(page));

        function onItemClick() {
          onNodeClick(group[0]);

          if (!isGreaterThanMedium) {
            closeSidebarLeft();
          }
        }

        return (
          <PagePreview
            key={`pages_preview_${group.join("_")}`}
            pages={group}
            humanReadablePages={humanReadablePages}
            isFirstPage={isFirstPage}
            isLastPage={isLastPage}
            isActive={isSelected}
            onClick={onItemClick}
            aspectRatio={aspectRatio}
          />
        );
      })}
    </List>
  );
}

PageList.propTypes = {
  onNodeClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  aspectRatio: PropTypes.number,
  isGreaterThanMedium: PropTypes.bool.isRequired,
  closeSidebarLeft: PropTypes.func.isRequired,
  pageFlow: PropTypes.array,
  pagesCount: PropTypes.number,
  displayedPages: PropTypes.array
};

function mapStateToProps(state) {
  return {
    aspectRatio: selectAspectRatio(state),
    isGreaterThanMedium: selectIsGreaterThanMedium(state),
    pageFlow: selectPageFlow(state),
    displayedPages: selectDisplayedPages(state),
    pagesCount: selectPagesCount(state)
  };
}

const mapDispatchToProps = {
  onNodeClick: goToPage,
  closeSidebarLeft
};

export default connect(mapStateToProps, mapDispatchToProps)(PageList);
